<template>
  <IntegrationsHelpDialog image item="integrationVacancyDialog">
    <template #image>
      <VImg :src="require('@/assets/img/integration2.png')" />
    </template>
    <template #text>
      <span v-html="$t('text')" />
    </template>
    <template #title>
      {{ $t('title') }}
    </template>
  </IntegrationsHelpDialog>
</template>

<script>
import IntegrationsHelpDialog from '@/components/Integrations/IntegrationsHelpDialog';

export default {
  name: 'IntegrationsHelpDialogVacancies',
  components: { IntegrationsHelpDialog },
  setup() {
  },
};
</script>

<style scoped>

</style>

<i18n lang="yml" locale="ru">
  title: Вы подключили сервис видеособеседований!
  text: 'Чтобы начать получать видеоотклики, вам необходимо настроить сценарии собеседований для импортированных вакансий.
  Нажмите на ссылку <b>“настроить сценарий собеседования”</b> рядом с вакансией и пройдите мастер подбора вопросов.'
</i18n>
